import React from 'react';
import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { DocsLink } from '../../constants/docs';
import FolderIcon from '../../assets/folder.png';
import { DSTheme } from '../../styles/themes/types';

type DocCardProps = {
  doc: DocsLink;
};

const DocsCard = styled('div')(({ theme }: { theme: DSTheme }) => ({
  width: '216px',
  height: '216px',
  padding: '32px',
  background: theme.palette.background.elevation1,
  boxShadow: '0px 5px 26px rgba(0, 0, 0, 0.06)',
  borderRadius: 16,

  [theme.breakpoints.up('md')]: {
    width: '234px',
    height: '234px',
  },

  '& a': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
}));

const DocCard: React.FC<DocCardProps> = ({ doc }) => (
  <DocsCard>
    <Typography variant="subtitle1">{doc.name}</Typography>

    <a href={doc.link} target="_blank" rel="noopener noreferrer">
      <img src={FolderIcon} alt={doc.name} />
    </a>
  </DocsCard>
);

export default DocCard;
